import { FormValues } from './FormValues';

export const defaultFormValues: FormValues = {
  attendants: [],
  driver: undefined,
  vehicle: undefined,
};
